import api from './client'

export const notasVentaApi = {
  listar: (params) => api.get('/notas-venta', { params }),
  crear: (data) => api.post('/notas-venta', data),
  obtener: (id) => api.get(`/notas-venta/${id}`),
  // Links de pago de Mobbex / Mercado Pago generados desde la NV (2 oct 2026).
  linksPago: (id) => api.get(`/notas-venta/${id}/links-pago`),
  crearLinkPago: (id, data) => api.post(`/notas-venta/${id}/links-pago`, data),
  anularLinkPago: (id, linkId) => api.post(`/notas-venta/${id}/links-pago/${linkId}/anular`),
  // Cobro hecho por fuera de LGR (link del panel de Mobbex / MP): se consulta y se trae por el nº de operación.
  consultarCobroPasarela: (id, gateway, ref) => api.get(`/notas-venta/${id}/cobro-pasarela`, { params: { gateway, ref }, timeout: 60000 }),
  registrarCobroPasarela: (id, gateway, ref) => api.post(`/notas-venta/${id}/cobro-pasarela`, { gateway, ref }, { timeout: 60000 }),
  actualizar: (id, data) => api.put(`/notas-venta/${id}`, data),
  enviar: (id, data) => api.post(`/notas-venta/${id}/enviar`, data),
  cambiarCliente: (id, clienteId, extra = {}) => api.post(`/notas-venta/${id}/cambiar-cliente`, { cliente_id: clienteId, ...extra }),
  // Contacto post-venta ELEGIDO para el pedido (hereda: comprobantes, avisos
  // de entrega, encuesta). email vacío = volver al de la ficha.
  emailContacto: (id, email) => api.put(`/notas-venta/${id}/email-contacto`, { email }),
  // Encuesta de satisfacción (compra) mandada por el vendedor — Sugerencia #111.
  // obtenerEncuesta crea la encuesta si no existe (mismo token que el mail de las 48 h).
  obtenerEncuesta: (id) => api.post(`/notas-venta/${id}/encuesta-compra`),
  marcarEncuestaEnviada: (id, canal) => api.post(`/notas-venta/${id}/encuesta-compra/enviada`, { canal }),
  frenar: (id, motivo = '') => api.post(`/notas-venta/${id}/frenar`, { motivo }),
  frenarMails: (id) => api.post(`/notas-venta/${id}/frenar-mails`),   // ✉️ corta los mails de recupero, la NV sigue activa
  reabrir: (id) => api.post(`/notas-venta/${id}/reabrir`),
  archivar: (ids, motivo) => api.post('/notas-venta/archivar', { ids, ...(motivo ? { motivo } : {}) }),
  dejar: (ids) => api.post('/notas-venta/dejar', { ids }),
  retomar: (ids) => api.post('/notas-venta/retomar', { ids }),
  // Marca "sin recibo" (venta sin cobro: canje MKT, prueba) — el ciclo F/P/R
  // la da por completa con factura + remito.
  sinRecibo: (id, motivo) => api.post(`/notas-venta/${id}/sin-recibo`, { motivo }),
  quitarSinRecibo: (id) => api.post(`/notas-venta/${id}/quitar-sin-recibo`),
  desarchivar: (ids) => api.post('/notas-venta/desarchivar', { ids }),
  eliminar: (id) => api.delete(`/notas-venta/${id}`),
  pdf: (id) => api.get(`/notas-venta/${id}/pdf`),
  // Stock en vivo desde Presea (query STOCK_NV, depósitos 100/400) — una
  // llamada al WS por código, puede tardar varios segundos con muchos renglones.
  stockPresea: (codigos) => api.post('/notas-venta/stock-presea', { codigos }, { timeout: 60000 }),
}

export const clientesApi = {
  buscar: (q) => api.get('/clientes', { params: { q, activos: true } }),
  obtener: (id) => api.get(`/clientes/${id}`),
  historiaPresea: (id, desde, hasta) =>
    api.get(`/clientes/${id}/historia-presea`, { params: { desde, hasta } }),
  // Historial orientado a CRM (31 oct 2026): NV, entregas, reseñas, mensajes…
  historialCrm: (id, desde, hasta) =>
    api.get(`/clientes/${id}/historial-crm`, { params: { desde, hasta } }),
  renglonesComprobante: (id, numero, formulario) =>
    api.get(`/clientes/${id}/comprobantes/${numero}/renglones`, { params: { formulario } }),
  // URL del export (descarga autenticada vía descargarArchivo)
  historiaExportUrl: (id, desde, hasta, formato) =>
    `/clientes/${id}/historia-presea/export?desde=${encodeURIComponent(desde)}&hasta=${encodeURIComponent(hasta)}&formato=${formato}`,
  deudores: (params) => api.get('/clientes/deudores', { params }),
  deudoresCompleto: (params) => api.get('/clientes/deudores/completo', { params }),
  // Vendedores que TIENEN deuda (llena el selector; no confundir con
  // /usuarios/vendedores, que son los usuarios de LGR).
  deudoresVendedores: (params) => api.get('/clientes/deudores/vendedores', { params }),
  deudoresDetalle: (cod, params) => api.get(`/clientes/deudores/${cod}/detalle`, { params }),
  deudoresExportUrl: (params) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== '' && v != null)).toString()
    return `/clientes/deudores/export?${qs}`
  },
  listaNegra: () => api.get('/clientes/lista-negra'),
  bloquear: (id, motivo) => api.post(`/clientes/${id}/bloquear`, { motivo }),
  desbloquear: (id) => api.post(`/clientes/${id}/desbloquear`),
  // IPs cortadas en la tienda SIN lista negra del cliente (11 oct 2026)
  ipsBloqueadas: () => api.get('/ips-bloqueadas'),
  bloquearIp: (ip, motivo) => api.post('/ips-bloqueadas', { ip, motivo }),
  desbloquearIp: (id) => api.delete(`/ips-bloqueadas/${id}`),
  // Productos restringidos por fraude (sin Mobbex en la tienda)
  restringidos: () => api.get('/productos-restringidos'),
  restringir: (tipo, valor, motivo) => api.post('/productos-restringidos', { tipo, valor, motivo }),
  quitarRestringido: (id) => api.delete(`/productos-restringidos/${id}`),
  resolverSugerenciaRestringido: (id, accion) => api.post(`/productos-restringidos/sugerencias/${id}/${accion}`),
}

export const articulosApi = {
  // clienteId opcional: si viene, el backend también matchea el SKU propio
  // del cliente y devuelve `codigo_cliente` en la fila.
  // lista opcional (código, ej. LISTA1): solo artículos CON PRECIO en esa
  // lista — el buscador de NV manda la lista que se está aplicando.
  buscar: (q, clienteId = null, lista = null) => api.get('/articulos', {
    params: { q, activos: true, disponibles_primero: 1, ...(clienteId ? { cliente_id: clienteId } : {}), ...(lista ? { lista } : {}) },
  }),
  // Ficha completa (maestro + precios + estado web + estado Presea + foto)
  obtener: (id) => api.get(`/articulos/${id}`),
  crear: (data) => api.post('/articulos', data),
  actualizar: (id, data) => api.put(`/articulos/${id}`, data),
  facetas: (campo) => api.get('/articulos/facetas', { params: { campo } }),
  // Stock de la web (campo propio de LGR) — desde el listado o la ficha, de a uno o en lote.
  stockWeb: (ids, enStock) => api.post('/articulos/stock-web', { ids, en_stock: enStock }),
  // destino: 'principal' | 'extra' (galería). ia: null (pregunta si el fondo no es blanco) | 'si' (Gemini) | 'no' (subirla así).
  subirFoto: (id, file, { destino = 'principal', ia = null } = {}) => {
    const fd = new FormData()
    fd.append('foto', file)
    fd.append('destino', destino)
    if (ia) fd.append('ia', ia)
    return api.post(`/articulos/${id}/foto`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: ia === 'si' ? 180000 : undefined })
  },
  // Sin n quita la principal (la primera adicional ocupa su lugar); con n, esa adicional.
  borrarFoto: (id, n = null) => api.delete(`/articulos/${id}/foto`, { params: n ? { n } : {} }),
  hacerFotoPrincipal: (id, n) => api.post(`/articulos/${id}/foto/principal`, { n }),
}

/** URL de la foto de un artículo ({SKU}.jpg servida por el backend/nginx). */
export const fotoArticuloUrl = (codigoAlfa) =>
  codigoAlfa ? `/productos/${String(codigoAlfa).toUpperCase()}.jpg` : null

export const clienteCodigosApi = {
  listar: (clienteId) => api.get(`/clientes/${clienteId}/codigos-articulo`),
  crear: (clienteId, data) => api.post(`/clientes/${clienteId}/codigos-articulo`, data),
  eliminar: (clienteId, codigoId) => api.delete(`/clientes/${clienteId}/codigos-articulo/${codigoId}`),
}

// Plan B: importar a LGR lo facturado A MANO en Presea (por fecha, agrupado
// por NV de Presea). Ver ImportacionPreseaService en el backend.
export const importacionPreseaApi = {
  previa: (fecha, vendedor) => api.get('/notas-venta/importar-presea', { params: { fecha, vendedor } }),
  importar: (fecha, notas) => api.post('/notas-venta/importar-presea', { fecha, notas }),
}
